import { useTheme } from "@/components/ThemeProvider";
import { isDarkTheme } from "@/lib/themes";
import { cn } from "@/lib/utils/cn";

import lawWorksBlackBg from "../../../assets/LawWorksBlackBg.png";
import lawWorksWhiteBg from "../../../assets/LawWorksWhiteBg.png";

type LawWorksLogoVariant = "black" | "white" | "auto";

export const LawWorksLogo = ({
  className,
  variant = "auto",
}: {
  className?: string;
  variant?: LawWorksLogoVariant;
}) => {
  const { theme } = useTheme();

  const resolvedVariant =
    variant === "auto" ? (isDarkTheme(theme) ? "black" : "white") : variant;

  const src = resolvedVariant === "white" ? lawWorksWhiteBg : lawWorksBlackBg;

  return <img src={src} className={cn("", className)} />;
};
